import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const dMDomainsTubeWhitelistApi = createApi({
  reducerPath: 'dMDomainsTubeWhitelistApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Domains-tube-whitelist'],
  endpoints: (builder) => ({
    getDomainsTubeWhitelist: builder.query({
      query: (params) => ({
        url: `/domains/tubes-whitelist-channels/`,
        params,
      }),
      providesTags: ['Domains-tube-whitelist'],
    }),

    createDomainTubeWhitelist: builder.mutation({
      query: (body) => ({
        url: '/domains/tubes-whitelist-channels/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Domains-tube-whitelist'],
    }),

    getDomainTubeWhitelistById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/domains/tubes-whitelist-channels/${id}/`,
        params,
      }),
      providesTags: (result, error, { id }) => [{ type: 'Domains-tube-whitelist', id }],
    }),

    updateDomainTubeWhitelistById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/domains/tubes-whitelist-channels/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Domains-tube-whitelist'],
    }),

    deleteDomainTubeWhitelistById: builder.mutation({
      query: (id) => ({
        url: `/domains/tubes-whitelist-channels/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Domains-tube-whitelist'],
    }),

    
  }),
});

export const {
  useGetDomainsTubeWhitelistQuery,
  useLazyGetDomainsTubeWhitelistQuery,
  useCreateDomainTubeWhitelistMutation,
  useGetDomainTubeWhitelistByIdQuery,
  useUpdateDomainTubeWhitelistByIdMutation,
  useDeleteDomainTubeWhitelistByIdMutation,
} = dMDomainsTubeWhitelistApi;
